<template>
  <div class="barra-aviso-wrapper">
    <div class="barra-aviso">
      <div class="barra-aviso-conteudo">
        <div class="barra-aviso-texto">
          <strong>{{ titulo }}</strong>
          <span>{{ mensagem }}</span>

          <a
            v-if="textoBotao && linkBotao"
            :href="linkBotao"
            class="barra-aviso-botao"
            target="_blank"
          >
            {{ textoBotao }}
          </a>
        </div>
      </div>

      <button
        type="button"
        class="barra-aviso-fechar"
        @click="fechar"
        aria-label="Fechar aviso"
      >
        ✕
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageBarraAviso',

  props: {
    titulo: {
      type: String,
      default: 'Aviso'
    },
    mensagem: {
      type: String,
      default: ''
    },
    textoBotao: {
      type: String,
      default: ''
    },
    linkBotao: {
      type: String,
      default: ''
    }
  },

  methods: {
    fechar () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.barra-aviso-wrapper {
  width: 100%;
  position: sticky;
  top: 0;
  z-index: 10002;
  overflow: visible;
}

.barra-aviso {
  width: 100%;
  height: 54px;
  position: relative;
  background: linear-gradient(90deg, #c45a00 0%, #f28c28 55%, #ffb347 100%);
  color: #fff;
  display: flex;
  align-items: center;
  padding-right: 50px;
}

.barra-aviso-conteudo {
  padding: 10px 20px;
  display: flex;
  align-items: center;
  flex: 1;
}

.barra-aviso-texto {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  font-size: 14px;
}

.barra-aviso-texto strong {
  font-size: 15px;
}

.barra-aviso-botao {
  background: #fff;
  color: #c45a00;
  padding: 6px 16px;
  border-radius: 18px;
  font-size: 13px;
  font-weight: 600;
  text-decoration: none;
  margin-left: 8px;
  white-space: nowrap;
}

.barra-aviso-botao:hover {
  opacity: 0.9;
  text-decoration: none;
}

.barra-aviso-fechar {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
  cursor: pointer;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s ease;
  padding: 0;
}

.barra-aviso-fechar:hover {
  background: rgba(255, 255, 255, 0.3);
}

@media (max-width: 768px) {
  .barra-aviso {
    height: 48px;
    padding-right: 45px;
  }

  .barra-aviso-conteudo {
    padding: 8px 15px;
  }

  .barra-aviso-texto {
    align-items: flex-start;
    flex-direction: column;
    gap: 6px;
  }

  .barra-aviso-botao {
    margin-left: 0;
  }
}
</style>
